var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7C4.6 -1 15.4 -1 19 7",
    stroke: "#56626C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11C9.60603 11 9.21593 10.9224 8.85195 10.7716C8.48797 10.6209 8.15726 10.3999 7.87868 10.1213C7.6001 9.84274 7.37913 9.51203 7.22836 9.14805C7.0776 8.78407 7 8.39397 7 8C7 7.60603 7.0776 7.21593 7.22836 6.85195C7.37913 6.48797 7.6001 6.15726 7.87868 5.87868C8.15726 5.6001 8.48797 5.37913 8.85195 5.22836C9.21593 5.0776 9.60603 5 10 5C10.7956 5 11.5587 5.31607 12.1213 5.87868C12.6839 6.44129 13 7.20435 13 8C13 8.79565 12.6839 9.55871 12.1213 10.1213C11.5587 10.6839 10.7956 11 10 11Z",
    fill: "#56626C",
    stroke: "#56626C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEyeIcon);
export default __webpack_public_path__ + "static/media/openEyeIcon.31fa82c7d20c5f7ed6988994494788a2.svg";
export { ForwardRef as ReactComponent };